import { useState } from "react";
import css from "./CreateServiceTypeModal.module.css";
import { useDispatch } from "react-redux";
import { createServiceType } from "../../../../redux/crm/operations";
import toast from "react-hot-toast";
import { showToast } from "../../../../utils/showToast.js";
import { addServicesSubcategory } from "../../../../redux/settings/operations.js";
import ModalCloseIcon from "../../../sharedComponents/ModalCloseIcon/ModalCloseIcon";

export default function CreateServiceTypeModal({
  onClose,
  serviceParentId,
  setChosenServicesTypes,
}) {
  const [serviceTypeName, setServiceTypeName] = useState("");
  const [serviceTypeCost, setServiceTypeCost] = useState("");
  const dispatch = useDispatch();

  const handleChange = e => {
    const onlyNums = e.target.value.replace(/\D/g, ""); // удаляет всё, кроме цифр
    setServiceTypeCost(onlyNums);
  };

  const createNewServiceType = () => {
    const serviceTypeData = {
      name: serviceTypeName,
      price: Number(serviceTypeCost),
      parent_id: Number(serviceParentId),
    };

    // dispatch(createServiceType(serviceTypeData))
    dispatch(addServicesSubcategory(serviceTypeData))
      .unwrap()
      .then(result => {
        console.log("result", result);
        showToast("Вид послуги успішно доданий", "success");

        setChosenServicesTypes(prev => [
          ...prev,
          { id: result.id, name: result.name, price: result.price },
        ]);
        onClose();
      })
      .catch(err => {
        console.log("err", err);
        showToast(
          {
            title: "Щось пішло не так",
            description: "Будь ласка, спробуйте ще раз.",
          },
          "error"
        );
      });
  };

  return (
    <div className={css.modal}>
      <ModalCloseIcon onClose={onClose} />
      <p className={css.header}>
        Для додавання послуги введіть її назву та вартість
      </p>
      <input
        type="text"
        className={css.input}
        placeholder="Назва послуги"
        onChange={e => setServiceTypeName(e.target.value)}
        value={serviceTypeName}
      ></input>
      <input
        type="text"
        className={css.input}
        placeholder="Вартість послуги"
        onChange={handleChange}
        value={serviceTypeCost}
      />
      <div className={css.btnsWrapper}>
        <button type="button" className={css.closeBtn} onClick={onClose}>
          Скасувати
        </button>
        <button
          type="button"
          className={css.submitBtn}
          onClick={createNewServiceType}
          disabled={
            serviceTypeName.trim() === "" ||
            serviceTypeCost.trim() === "" ||
            Number(serviceTypeCost.trim()) === 0
          }
        >
          Зберегти
        </button>
      </div>
    </div>
  );
}
